{
  "name": "@ag-ui/client",
  "author": "Markus Ecker <markus.ecker@gmail.com>",
  "version": "0.0.43",
  "private": false,
  "publishConfig": {
    "access": "public"
  },
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "sideEffects": false,
  "files": [
    "dist/**",
    "README.md"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "clean": "rm -rf dist .turbo node_modules",
    "typecheck": "tsc --noEmit",
    "test": "jest",
    "link:global": "pnpm link --global",
    "unlink:global": "pnpm unlink --global"
  },
  "dependencies": {
    "@ag-ui/core": "workspace:*",
    "@ag-ui/encoder": "workspace:*",
    "@ag-ui/proto": "workspace:*",
    "@types/uuid": "^10.0.0",
    "compare-versions": "^6.1.1",
    "fast-json-patch": "^3.1.1",
    "rxjs": "7.8.1",
    "untruncate-json": "^0.0.1",
    "uuid": "^11.1.0",
    "zod": "^3.22.4"
  },
  "devDependencies": {
    "@types/jest": "^29.5.14",
    "@types/node": "^20.11.19",
    "jest": "^29.7.0",
    "ts-jest": "^29.1.2",
    "tsup": "^8.0.2",
    "typescript": "^5.3.3"
  }
}
